import { useMemo } from 'react';
import type { GeneralBalanceData } from '@/entities/account';
import type { BalanceRow } from './types';

const HINT_KEYS: Partial<Record<BalanceRow['key'], string>> = {
  processing: 'personalAccount.balanceDropdown.balance.processingHint',
  inTrading: 'personalAccount.balanceDropdown.balance.inTradingHint',
};

export const useBalanceRows = (general: GeneralBalanceData | null) =>
  useMemo<BalanceRow[]>(() => {
    if (!general) {
      return [];
    }

    const rows: BalanceRow[] = [
      { key: 'total', value: general.balance, locked: false },
      {
        key: 'processing',
        value: general.processing,
        locked: true,
        hintKey: HINT_KEYS.processing,
      },
      {
        key: 'inTrading',
        value: general.inTrading,
        locked: true,
        hintKey: HINT_KEYS.inTrading,
      },
      { key: 'available', value: general.available, locked: false },
    ];

    return rows.filter(row => !row.locked || row.value > 0);
  }, [general]);
